import { Agenda } from '@esportal/portal-service';
import { Gallery, ArrowButtons, Breakpoints, GallerySlide, Lentils } from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';
import { AgendaCard } from './agenda-card';
import { LentilsWrapper } from '../../ui/lentils-wrapper';

interface AgendaCarouselProps {
	agendas: Agenda[];
}

// añadir padding a las gallery slides para la shadow de la card
const GallerySlideContainer = styled(GallerySlide)`
	padding: 10px;
`;

export const AgendaCarousel = ({ agendas }: AgendaCarouselProps) => {
	return (
		<Gallery
			data-testid="agenda-gallery-slider"
			id="agenda-gallery"
			bottomElements={
				<>
					<ArrowButtons buttonPreviousAriaLabel="To previous slide" buttonNextAriaLabel="To next slide" />

					{/* si todas las slides caben en pantalla - no mostrar lentils */}
					<LentilsWrapper $count={agendas.length}>
						<Lentils />
					</LentilsWrapper>
				</>
			}
			aria-label="Agenda gallery"
			slidesPerPage={{
				[Breakpoints.default]: 1,
				[Breakpoints.b960]: agendas.length >= 2 ? 2 : agendas.length,
				[Breakpoints.b1600]: agendas.length >= 3 ? 3 : agendas.length,
				[Breakpoints.b2560]: agendas.length >= 4 ? 4 : agendas.length,
			}}
			fadingEdges="normal"
		>
			{[
				...agendas.map((agendaData, index) => (
					<GallerySlideContainer key={index} aria-labelledby={`slide${index}-heading`} stretch>
						<AgendaCard agenda={agendaData} />
					</GallerySlideContainer>
				)),
			]}
		</Gallery>
	);
};
